import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { catchAsync, checkResponse } from "../../../../utilities/utilies";
import { BASIC_SETTING_UPDATE } from "../../../../services/ApiCalls";

const schema = z.object({
  Android_User_App_Force_Update: z.boolean({
    required_error: "Android_User_App_Force_Update is required",
    invalid_type_error: "Android_User_App_Force_Update must be a boolean",
  }),
  SMS_Notification: z.boolean({
    required_error: "SMS_Notification is required",
    invalid_type_error: "SMS_Notification must be a boolean",
  }),
});

const NotificationSetting = ({ basicSettingData, setBasicSettingData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    values: {
      Android_User_App_Force_Update:
        basicSettingData?.Notifi_Settings.Android_User_App_Force_Update ||
        false,
      SMS_Notification:
        basicSettingData?.Notifi_Settings.SMS_Notification || false,
    },
  });

  const submitHandler = catchAsync(async (data) => {
    const res = await BASIC_SETTING_UPDATE({ Notifi_Settings: { ...data } });
    checkResponse({ res, showSuccess: true, setData: setBasicSettingData });
  });

  return (
    <div className="cardCstm p-3 border rounded">
      <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
        <h6 className="m-0 fw-sbold themeBlue">Notification Setting</h6>
      </div>
      <form className="cardBody" onSubmit={handleSubmit(submitHandler)}>
        <ul className="list-unstyled ps-0 mb-0 py-2">
          <li className="py-2 border-bottom d-flex align-items-center justify-content-between">
            <p className="m-0 fw-sbold d-flex align-items-center gap-10">
              <span className="icn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4 8C3.99945 6.75336 4.38723 5.5375 5.10945 4.52138C5.83167 3.50525 6.85247 2.73931 8.03 2.33C7.9844 2.04431 8.00132 1.75213 8.0796 1.47361C8.15788 1.1951 8.29565 0.936882 8.48341 0.716779C8.67117 0.496676 8.90444 0.319927 9.16714 0.198728C9.42983 0.077528 9.71569 0.0147629 10.005 0.0147629C10.2943 0.0147629 10.5802 0.077528 10.8429 0.198728C11.1056 0.319927 11.3388 0.496676 11.5266 0.716779C11.7143 0.936882 11.8521 1.1951 11.9304 1.47361C12.0087 1.75213 12.0256 2.04431 11.98 2.33C13.1557 2.74099 14.1743 3.50764 14.8946 4.52363C15.615 5.53961 16.0013 6.75457 16 8V14L19 16V17H1V16L4 14V8ZM12 18C12 18.5304 11.7893 19.0391 11.4142 19.4142C11.0391 19.7893 10.5304 20 10 20C9.46957 20 8.96086 19.7893 8.58579 19.4142C8.21071 19.0391 8 18.5304 8 18H12Z"
                    fill="#454545"
                  />
                </svg>
              </span>
              SMS Notification
            </p>
            <Form.Check // prettier-ignore
              type="switch"
              id="custom-switch"
              label=""
              {...register("SMS_Notification")}
            />
          </li>
          <li className="py-2 border-bottom d-flex align-items-center justify-content-between">
            <p className="m-0 fw-sbold d-flex align-items-center gap-10">
              <span className="icn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 27"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2_2)">
                    <path
                      d="M4.16668 0C2.32814 0 0.833344 1.49479 0.833344 3.33333V23.3333C0.833344 25.1719 2.32814 26.6667 4.16668 26.6667H15.8333C17.6719 26.6667 19.1667 25.1719 19.1667 23.3333V3.33333C19.1667 1.49479 17.6719 0 15.8333 0H4.16668ZM8.33334 22.5H11.6667C12.125 22.5 12.5 22.875 12.5 23.3333C12.5 23.7917 12.125 24.1667 11.6667 24.1667H8.33334C7.87501 24.1667 7.50001 23.7917 7.50001 23.3333C7.50001 22.875 7.87501 22.5 8.33334 22.5Z"
                      fill="#454545"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2_2">
                      <rect width="20" height="26.6667" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Android User App Force Update
            </p>
            <Form.Check // prettier-ignore
              type="switch"
              id="custom-switch"
              label=""
              {...register("Android_User_App_Force_Update")}
            />
          </li>
        </ul>
        <div className="btnWrpper mt-3">
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            type="submit"
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default NotificationSetting;
